import {Box, useMediaQuery, useTheme} from '@mui/material';
import * as React from 'react'
import { ImageList, ImageListItem, Dialog, DialogContent, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import HeaderImage from '../components/HeaderImage';

const itemData = [
    {img: "/carousel-1.jpg", title: 'Nature', rows: 2, cols: 2},
    {img: "/carousel-2.jpg", title: 'Water'},
    {img: "/carousel-3.jpg", title: 'Forest'},
    {img: "/carousel-4.jpg", title: 'Mountain'},
    {img: "/carousel-3.jpg", title: 'Forest'},
    {img: "/carousel-4.jpg", title: 'Mountain'},
    {img: "/carousel-1.jpg", title: 'Nature', rows: 2, cols: 2},
]

function srcset(image: string, size: number, rows = 1, cols = 1) {
    return {
        src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
        srcSet: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format&dpr=2 2x`,
    }
}

function Salon() {
    const [open, setOpen] = React.useState(false)
    const [selectedImage, setSelectedImage] = React.useState<string | null>(null)

    const theme = useTheme()
    const isXs = useMediaQuery(theme.breakpoints.down("sm"))
    const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"))

    const handleOpen = (img: string) => {
        setSelectedImage(img)
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        setSelectedImage(null)
    }

    const cols = isXs ? 2 : isSm ? 3 : 4

    return (
        <>
            <HeaderImage/>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 4,
                }}
            >
                <ImageList
                    variant="quilted"
                    rowHeight={isXs ? 100 : 121}
                    cols={cols}
                    gap={8}
                    sx={{
                        width: {xs: "90%", sm: "90%", md: "80%", lg: "900px"},
                        height: "auto",
                    }}
                >
                    {itemData.map((item) => (
                        <ImageListItem
                            key={item.img}
                            cols={item.cols || 1}
                            rows={item.rows || 1}
                            sx={{cursor: 'pointer'}}
                            onClick={() => handleOpen(item.img)}
                        >
                            <img
                                {...srcset(item.img, 121, item.rows, item.cols)}
                                alt={item.title}
                                loading="lazy"
                                style={{width: "100%", height: "100%", objectFit: "cover"}}
                            />
                        </ImageListItem>
                    ))}
                </ImageList>
            </Box>

            <Dialog open={open} onClose={handleClose} maxWidth="lg">
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'grey',
                        zIndex: 1,
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent sx={{p: 0, backgroundColor: 'black'}}>
                    {selectedImage && (
                        <img
                            src={selectedImage}
                            alt="powiększone zdjęcie"
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '90vh',
                                objectFit: 'contain',
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </>
    )
}

export default Salon
